import React from "react";

const SMALL_CAPS_TONE = {
  brass: "text-espresso",
  ivory: "text-ivory/80",
  graphite: "text-graphite/80",
};

export const SmallCaps = ({ children, className = "", tone = "brass", ...rest }) => (
  <span
    className={`inline-block text-[11px] font-sans uppercase tracking-widest ${
      SMALL_CAPS_TONE[tone] || SMALL_CAPS_TONE.graphite
    } ${className}`}
    {...rest}
  >
    {children}
  </span>
);

export const BrassRule = ({ className = "" }) => (
  <div className={`brass-rule ${className}`} aria-hidden="true" />
);

/** Pill CTA — primary (solid graphite), secondary (outlined), ghost (text). */
export const PillCTA = ({ variant = "primary", as: As = "button", className = "", children, ...rest }) => {
  const base =
    "inline-flex items-center justify-center rounded-full px-8 py-3 text-[11px] font-sans uppercase tracking-widest transition-colors duration-300 ease-out select-none";
  const styles = {
    primary: "bg-graphite text-ivory hover:bg-espresso",
    secondary: "border border-graphite text-graphite hover:bg-graphite hover:text-ivory",
    ghost: "text-graphite hover:text-espresso",
    onDark: "border border-ivory/60 text-ivory hover:bg-ivory hover:text-graphite",
  };
  return (
    <As className={`${base} ${styles[variant]} ${className}`} {...rest}>
      {children}
    </As>
  );
};
